<template>
  <div class="about-pc">
    <h2>摄像头检测</h2>
    <tab :active=2></tab>
    <div class="content" v-if="!isError">
      <p class="tip">{{ tip }}</p>
      <div class="camera-wrap">
        <div class="no-camera flex-row-center" v-show="!showVideo">
          <p class="icon-people"></p>
          <span class="box left-top"></span>
          <span class="box right-top"></span>
          <span class="box left-bottom"></span>
          <span class="box right-bottom"></span>
        </div>
        <camera
          class="camera"
          ref="detectCamera"
          :video-width="videoWidth"
          :video-height="videoHeight"
          @openVideo="openVideo"
          @handleError="handleError"
        ></camera>
      </div>
      <div class="btn-wrap" v-show="showVideo">
        <button class="empty-btn" @click="setInfo(0)">看不到</button>
        <button class="fill-btn" @click="setInfo(1)">看得到</button>
      </div>
    </div>
    <div class="error-content" v-if="isError">
      <p class="tips"><span>摄像头</span>检测异常~</p>
      <p class="countdown">自动跳转下一步…{{ countdown }}s</p>
    </div>
  </div>
</template>

<script>
import Tab from './Tab'
import Camera from '@/views/components/OpenCamera'

export default {
  components: {
    Tab,
    Camera
  },
  data() {
    return {
      videoWidth: 238,
      videoHeight: 158,
      showVideo: false,
      tip: '',
      isError: false,
      countdown: 3,
      timer: null
    }
  },
  mounted() {
    this.tip = '当出现弹框时，请点击“允许”或“Allow”～'
    this.showVideo = false
    this.$refs.detectCamera.getCompetence()
  },
  methods: {
    openVideo() {
      this.showVideo = true
      this.tip = '请将面部放到摄像框内哦～'
    },
    setInfo(val) {
      let type = ''
      if (val === 0) {
        type = 'h'
      } else {
        type = 'i'
      }
      this.$emit('setCameraInfo', type)
      this.$emit('nextStep', 2)
      this.closeVideo()
    },
    closeVideo() {
      if (this.$refs.detectCamera) {
        this.$refs.detectCamera.stopNavigator()
      }
    },
    handleError(type) {
      this.$emit('setCameraInfo', type)
      this.isError = true
      this.timer = setInterval(() => {
        this.countdown -= 1
        if (this.countdown === 0) {
          clearInterval(this.timer)
          this.$emit('nextStep', 2)
        }
      }, 1000)
    }
  },
  destroyed() {
    this.closeVideo()
  }
}
</script>

<style lang="scss" scoped>
  .about-pc {
    padding-bottom: 50px;
  }
  .content {
    margin-top: 34px;
  }
  .camera-wrap {
    margin: 14px auto auto;
    position: relative;
    background-color: #eee;
    width: 240px;
    height: 160px;
    border-radius: 8px;
    border: .5px solid #B0B0B0;
  }
  .no-camera {
    height: 100%;
    .box {
      display: inline-block;
      position: absolute;
      width: 15px;
      height: 15px;
      border: 3px solid #bbb;
    }
    .left-top {
      left: 15px;
      top: 15px;
      border-right: 0;
      border-bottom: 0;
    }
    .left-bottom {
      left: 15px;
      bottom: 15px;
      border-right: 0;
      border-top: 0;
    }
    .right-top {
      right: 15px;
      top: 15px;
      border-left: 0;
      border-bottom: 0;
    }
    .right-bottom {
      right: 15px;
      bottom: 15px;
      border-left: 0;
      border-top: 0;
    }
  }
  .icon-people {
    display: inline-block;
    width: 123px;
    height: 131px;
    background: url("~@/assets/images/detect/icon-people.png") center / cover no-repeat;
  }
  .camera {
    /deep/ video {
      border-radius: 8px;
    }
  }
  .btn-wrap {
    margin-top: 40px;
  }
  .empty-btn {
    @include theme-empty-btn(144px, 42px, 16px, 4px);
    margin-right: 60px;
  }
  .fill-btn {
    @include theme-fill-btn(144px, 42px, 16px, 4px);
  }
  .error-content {
    margin-top: 113px;
    .tips {
      font-size: 16px;
      color: #333;
      span {
        font-size: 20px;
        font-weight: 500;
      }
    }
    .countdown {
      margin-top: 150px;
      font-size: 14px;
      color: #666;
    }
  }
</style>
